import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { from, Observable } from 'rxjs';
import { OrderCustomerModel, PageBase, LocationInfo, VehicleInfo, NoteInfo, User } from 't4core';
import { T4DatatableWidget } from '../../../../t4common';
import moment from 'moment';
import { debounceTime, distinctUntilChanged, finalize, switchMap, tap } from 'rxjs/operators';

@Component({
    selector: 'UserManagement',
    templateUrl: './UserManagement.html',
    styleUrls: ['./UserManagement.css']
})

export class UserManagement extends PageBase {

    @ViewChild("usersInRoleTbl", { static: false }) usersInRoleTbl: T4DatatableWidget;

    public roles: any[];

    public usersInRole: any[] = [];
    public txtUser = new FormControl();
    public selectedUser: User;
    public filteredUsers: Observable<User[]>;

    public queryParameters = {};

    public showUsedStock = true;

    public selectedRole: any;

    public loading = false;

    public isLoading: boolean = false;

    timeout: any = null;
    constructor(el: ElementRef, private router: Router, private route: ActivatedRoute) {

        super(el, "Order");

      //  this.txtUser.valueChanges.subscribe(x => {
      //      this.filteredUsers = from(this.Api.get<User[]>("/Settings/FilterUsers", { searchText: x, limit: 50 }));
      //  });


      this.filteredUsers = this.txtUser.valueChanges.pipe(
        debounceTime(800), 
        tap(() => this.isLoading = true), 
        switchMap(searchText => {
          return from(this.Api.get<User[]>("/Settings/FilterUsers", { searchText, limit: 50 })).pipe(
            finalize(() => this.isLoading = false) 
          );
        })
      );

   
    }

    async ngOnInit() {

        await this.getRoles();
        await this.getUsersWithRole();
    }

    public async getRoles() {
      this.roles = await this.Api.get<any[]>("Settings/GetRoles");
    }

    public async removeRoleFromUser(row) {
        var x = await this.UI.confirm("Turbo.Settings.Groups.RemoveUserRoleTtl", "Remove from group?", "RemoveUserRoleMsg", "Are you sure you want to remove {0} from this group?", null, [row.Username]);

        if (x) {
            var removed = await this.Api.get<boolean[]>("Settings/RemoveRoleFromUser", { UserName: row.Username, roleId: this.selectedRole.Id });

            if (removed) {
                this.usersInRole = await this.Api.get<any[]>("Account/GetUsersWithRole", { roleId: this.selectedRole.Id });
                await this.UI.alert("Turbo.General.SuccessTtl", "Success!", "Turbo.General.SuccessMsg", "The action has been performed succesfully!");
            }
            else {
                await this.UI.alert("Turbo.General.FailedTtl", "Failed!", "Turbo.General.FailedMsg", "The action failed!");
            }
            await this.getUsersWithRole();
        }

    }

  public async addUserToRole() {
    
    var user = await this.UI.openDialog<User>("T4.Settings.FindUser", { width: '500px', data: {} });
        if (user) {
            var added = await this.Api.get<boolean[]>("Settings/AddRoleToUser", { UserName: user.Username, roleId: this.selectedRole.Id });
            if (added) {
                this.usersInRole = await this.Api.get<any[]>("Account/GetUsersWithRole", { roleId: this.selectedRole.Id });
                await this.UI.alert("Turbo.General.SuccessTtl", "Success!", "Turbo.General.SuccessMsg", "The action has been performed succesfully!");
            }
            else {
                await this.UI.alert("Turbo.General.FailedTtl", "Failed!", "Turbo.General.FailedMsg", "The action failed!");
            }
            await this.getUsersWithRole();
        }
    }

    public async getUsersWithRole() {
      if (!this.selectedRole) {
        if (this.roles && this.roles.length > 0) this.selectedRole = this.roles[0];
        }

      this.loading = true;
      this.usersInRole = await this.Api.get<any[]>("Account/GetUsersWithRole", { roleId: this.selectedRole.Id });
      this.loading = false;
    }

    public async selectUser(item) {
        this.selectedUser = item;
    }

  public async newUser() {
       await this.UI.openDialog("T4.Settings.EditUser", { width: '900px', data: { user: null } });
    }

    public async editUser(user) {
        await this.UI.openDialog("T4.Settings.EditUser", { width: '900px', data: { user: user } });
        await this.getUsersWithRole();
    }

  
}
